import React, { useContext, useEffect } from 'react';
import { Route, Redirect, BrowserRouter as Router, Switch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { useState } from 'react';

//ui
import Container from '@material-ui/core/Container';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

//custom
import AppNavBar from './AppNavBar';
import Home from './components/Home';
import Info from './components/home/Info';
import Admin from './components/Admin';
import AuthorizeRoute from './components/_shared/AuthorizeRoute';

//auth
import ApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import { ApplicationPaths, QueryParameterNames } from './components/api-authorization/ApiAuthorizationConstants';
import authService from './components/api-authorization/AuthorizeService';

import { appStore } from './appStore.js';

const App = (props) => {
  const { t } = useTranslation();
  const { state, dispatch } = useContext(appStore);
  const [sessionExpiredDialogOpen, setSessionExpiredDialogOpen] = useState(false);
  const [sessionExpiredReturnUrl, setSessionExpiredReturnUrl] = useState('/');
  let subscription;

  const normalizeReturnUrl = (candidateUrl) => {
    if (!candidateUrl) {
      return `${window.location.origin}/`;
    }

    if (candidateUrl.startsWith('http://') || candidateUrl.startsWith('https://')) {
      return candidateUrl;
    }

    return `${window.location.origin}${candidateUrl.startsWith('/') ? '' : '/'}${candidateUrl}`;
  };

  const tabs = [
    { label: t('pages:admin'), path: '/admin', roles: ['QualityAdmin'] },
  ];
  const theme = createMuiTheme({
    overrides: {
      MuiListItemText: {
        primary: {
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        },
        secondary: {
          fontSize: '75%',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        },
      },
    },
    palette: {
      primary: {
        // light: '#ff7961',
        main: state.navigatingAdmin ? '#8B0000' : (state.league && state.league.mainColorCode ? state.league.mainColorCode : '#0665fb'),
        // dark: '#ff7961',
        contrastText: state.league && state.league.secondaryColorCode ? state.league.secondaryColorCode : '#fff',
      },
      secondary: {
        // light: '#ff7961',
        main: state.league && state.league.secondaryColorCode ? state.league.secondaryColorCode : '#71bf44',
        // dark: '#ff7961',
        contrastText: state.league && state.league.secondaryColorCode ? state.league.secondaryColorCode : '#fff',
      },
      // Used by `getContrastText()` to maximize the contrast between
      // the background and the text.
      contrastThreshold: 10,
      // Used by the functions below to shift a color's luminance by approximately
      // two indexes within its tonal palette.
      // E.g., shift from Red 500 to Red 300 or Red 700.
      tonalOffset: 0.2,
    },
  });

  useEffect(() => {
    const init = async () => {
      subscription = authService.subscribe(() => populateAuthenticationState());
      await populateAuthenticationState();
    };
    init();
    return () => {
      authService.unsubscribe(subscription);
    }
  }, []);

  useEffect(() => {
    const onSessionExpired = (event) => {
      const fallbackUrl = `${window.location.origin}${window.location.pathname}${window.location.search}${window.location.hash}`;
      const returnUrl = event && event.detail && event.detail.returnUrl ? event.detail.returnUrl : fallbackUrl;
      setSessionExpiredReturnUrl(normalizeReturnUrl(returnUrl));
      setSessionExpiredDialogOpen(true);
    };

    window.addEventListener('syncstats:session-expired', onSessionExpired);
    return () => {
      window.removeEventListener('syncstats:session-expired', onSessionExpired);
    };
  }, []);

  const reconnect = () => {
    window.location.assign(`${ApplicationPaths.Login}?${QueryParameterNames.ReturnUrl}=${encodeURIComponent(normalizeReturnUrl(sessionExpiredReturnUrl || '/'))}`);
  };

  const populateAuthenticationState = async () => {
    let user = state.user;
    if (!user) {
      user = await authService.getUser();
      dispatch({ type: 'updateUser', payload: { user: user, isReady: true } });
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Router>

        <AppNavBar
          position="fixed"
        />

        <Container>

          <Switch>

            <Route exact path='/' render={(props) =>
              <Redirect to="/home" />
            } />

            <Route path='/home' render={(props) =>
              <Home {...props} />
            } />

            <AuthorizeRoute exact={false} path='/admin' component={Admin} noAccess={true} roles={['Admin']} />

            <Route path={ApplicationPaths.ApiAuthorizationPrefix} render={(props) =>
              <ApiAuthorizationRoutes {...props} />
            } />

            <Route render={(props) =>
              <div>Not found</div>
            } />

          </Switch>
        </Container>

        <Dialog
          open={sessionExpiredDialogOpen}
          disableBackdropClick
          disableEscapeKeyDown
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>Session expiree</DialogTitle>
          <DialogContent>
            <Typography>
              Vous avez ete deconnecte. Veuillez vous reconnecter pour continuer.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button color="primary" variant="contained" onClick={reconnect}>
              Se reconnecter
            </Button>
          </DialogActions>
        </Dialog>
      </Router>

    </ThemeProvider>
  );
}
export default App;
